/* Epic header — sticky scroll state + live cart count.
   Install: Edit code > Assets > Add a new asset > name: epic-header.js > paste. */
(function () {
  var header = document.querySelector('[data-epic-header]');
  if (!header) return;

  var THRESHOLD = 80;
  var last = false, ticking = false;

  function update() {
    var scrolled = window.scrollY > THRESHOLD;
    if (scrolled !== last) {
      header.classList.toggle('epic-header--scrolled', scrolled);
      last = scrolled;
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();

  // Keep cart count fresh when items are added (Dawn publishes cart updates)
  document.addEventListener('cart:updated', refreshCount);
  document.addEventListener('cart:refresh', refreshCount);
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-cart-count]');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }
})();